import React, { useState } from "react";
import { Badge, Row, Col } from "react-bootstrap";
import {
  CommonInput,
  CommonSelect,
  CommonDatePicker,
  CommonButton,
} from "../Input";
import DataTable from "../table/DataTable";

const ReportList = () => {
  const [filters, setFilters] = useState({
    email: "",
    startDate: null,
    endDate: null,
    type: null,
    role: null,
  });

  const typeOptions = [
    { value: "all", label: "All Types" },
    { value: "topup", label: "Top-up" },
    { value: "login", label: "Login" },
    { value: "logout", label: "Logout" },
  ];

  const roleOptions = [
    { value: "teller", label: "Teller" },
    { value: "admin", label: "Admin" },
  ];

  const mockData = [
    {
      dateTime: "09/03/2026\n11:50:19",
      email: "nguyen-teller@yopmail.com",
      role: "Teller",
      action: "User Create Top-up",
      details:
        "Transaction ID: 257\nCustomer ID: 10844\nTop-up amount: 110117.00\nCurrency: SGD",
      ipAddress: "118.69.60.73",
      device:
        "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/144.0.0.0 Safari/537.36",
    },
    {
      dateTime: "09/03/2026\n09:53:02",
      email: "nguyen-teller@yopmail.com",
      role: "Teller",
      action: "Login",
      details: "Cash draw name: Hanh Nguyen",
      ipAddress: "118.69.60.73",
      device:
        "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/144.0.0.0 Safari/537.36",
    },
    {
      dateTime: "09/03/2026\n09:43:26",
      email: "nguyen-teller@yopmail.com",
      role: "Teller",
      action: "Logout",
      details: "Cash draw name: Hanh Nguyen",
      ipAddress: "118.69.60.73",
      device:
        "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/144.0.0.0 Safari/537.36",
    },
    {
      dateTime: "09/03/2026\n09:43:10",
      email: "nguyen-teller@yopmail.com",
      role: "Teller",
      action: "Login",
      details: "Cash draw name: Hanh Nguyen",
      ipAddress: "118.69.60.73",
      device:
        "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/144.0.0.0 Safari/537.36",
    },
    {
      dateTime: "09/03/2026\n09:29:41",
      email: "nguyen-teller@yopmail.com",
      role: "Teller",
      action: "Logout",
      details: "Cash draw name: Hanh Nguyen",
      ipAddress: "118.69.60.73",
      device:
        "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/144.0.0.0 Safari/537.36",
    },
    {
      dateTime: "09/03/2026\n09:29:33",
      email: "nguyen-teller@yopmail.com",
      role: "Teller",
      action: "Login",
      details: "Cash draw name: Hanh Nguyen",
      ipAddress: "118.69.60.73",
      device:
        "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/144.0.0.0 Safari/537.36",
    },
  ];

  const [filteredData, setFilteredData] = useState(mockData);

  const columns = [
    {
      label: "Date Time",
      key: "dateTime",
      cellStyle: () => ({ whiteSpace: "pre-line", fontSize: "12px" }),
    },
    {
      label: "Email",
      key: "email",
      render: (item) => <span className="text-black">{item.email}</span>,
    },
    { label: "Role", key: "role" },
    {
      label: "Action",
      key: "action",
      render: (item) => (
        <Badge
          bg="light"
          className="text-black border-0 fw-bold px-3 py-2"
          style={{
            borderRadius: "8px",
            fontSize: "11px",
            backgroundColor: "#f2f4f7",
          }}
        >
          {item.action}
        </Badge>
      ),
    },
    {
      label: "Details",
      key: "details",
      cellStyle: () => ({
        whiteSpace: "pre-line",
        fontSize: "12px",
        maxWidth: "250px",
      }),
    },
    { label: "IP Address", key: "ipAddress" },
    {
      label: "Device",
      key: "device",
      cellStyle: () => ({
        fontSize: "11px",
        maxWidth: "300px",
        color: "#667085",
      }),
    },
  ];

  const handleSearch = () => {
    const result = mockData.filter((item) => {
      // Email filter
      const matchEmail = filters.email
        ? item.email.toLowerCase().includes(filters.email.toLowerCase())
        : true;

      // Role filter
      const matchRole = filters.role
        ? item.role.toLowerCase() === filters.role.value.toLowerCase()
        : true;

      // Type (Action) filter
      const matchType =
        filters.type && filters.type.value !== "all"
          ? item.action.toLowerCase().includes(filters.type.value.toLowerCase())
          : true;

      // Date range filter
      let matchDate = true;
      if (filters.startDate || filters.endDate) {
        const itemDateStr = item.dateTime.split("\n")[0]; // "09/03/2026"
        const [day, month, year] = itemDateStr.split("/").map(Number);
        const itemDate = new Date(year, month - 1, day);

        if (filters.startDate) {
          const start = new Date(filters.startDate);
          start.setHours(0, 0, 0, 0);
          if (itemDate < start) matchDate = false;
        }
        if (filters.endDate) {
          const end = new Date(filters.endDate);
          end.setHours(23, 59, 59, 999);
          if (itemDate > end) matchDate = false;
        }
      }

      return matchEmail && matchRole && matchType && matchDate;
    });
    setFilteredData(result);
  };

  const handleReset = () => {
    setFilters({
      email: "",
      startDate: null,
      endDate: null,
      type: null,
      role: null,
    });
    setFilteredData(mockData);
  };

  return (
    <div className="container-fluid">
      <h2 className="fw-bold text-black mb-0 fs-24 mb-4">Reports</h2>
      <div className="card mb-4" style={{ borderRadius: "10px" }}>
        <div className="card-body p-3">
          <Row className="align-items-end g-2">
            <Col xl={2} lg={4} md={6} sm={6}>
              <CommonInput
                label="Email"
                placeholder="Email"
                value={filters.email}
                onChange={(e) =>
                  setFilters({ ...filters, email: e.target.value })
                }
                wrapClass="w-100 mb-0"
              />
            </Col>
            <Col xl={2} lg={4} md={6} sm={6}>
              <CommonDatePicker
                label="Start Date"
                placeholder="mm / dd / yyyy"
                value={filters.startDate}
                onChange={(date) => setFilters({ ...filters, startDate: date })}
                wrapClass="w-100 mb-0"
              />
            </Col>
            <Col xl={2} lg={4} md={6} sm={6}>
              <CommonDatePicker
                label="End Date"
                placeholder="mm / dd / yyyy"
                value={filters.endDate}
                onChange={(date) => setFilters({ ...filters, endDate: date })}
                wrapClass="w-100 mb-0"
              />
            </Col>
            <Col xl={2} lg={4} md={6} sm={6}>
              <CommonSelect
                label="Type"
                placeholder="All Types"
                options={typeOptions}
                value={filters.type}
                onChange={(val) => setFilters({ ...filters, type: val })}
                wrapClass="w-100 mb-0"
              />
            </Col>
            <Col xl={2} lg={4} md={6} sm={6}>
              <CommonSelect
                label="Role"
                placeholder="Role"
                options={roleOptions}
                value={filters.role}
                onChange={(val) => setFilters({ ...filters, role: val })}
                wrapClass="w-100 mb-0"
              />
            </Col>
            <Col xl={2} lg={4} md={6} sm={6}>
              <div className="d-flex gap-2">
                <CommonButton
                  onClick={handleReset}
                  variant="outline"
                  className="flex-grow-1 h-45"
                >
                  <i className="flaticon-381-repeat-1"></i>
                </CommonButton>
                <CommonButton
                  onClick={handleSearch}
                  className="flex-grow-1 h-45"
                >
                  <i className="flaticon-381-search-1 fs-18 text-white"></i>
                </CommonButton>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
        <div className="card-body">
          <DataTable
            columns={columns}
            data={filteredData}
            showPagination={false}
            minWidth="100%"
          />
        </div>
      </div>
    </div>
  );
};

export default ReportList;
